import { useContext } from 'react';

import isMobile from 'ismobilejs';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';
import { css, styled } from '@ezbobdev/ui-widgets-ezbob';

import { PageWrapper } from '../../widgets';

const Wrapper = styled(PageWrapper)`
  ${({ theme, isFinal, isCentered, disclaimerVariant, backButton, moveBackButtonToBottom }) => {
    return css`
      .ScreenWrapper__header,
      .ScreenWrapper__custom-header {
        .ScreenWrapper__header__subtitle {
          margin-top: ${theme.spacing(1)};
        }
      }

      .ScreenWrapper__inner {
        text-align: center;

        .ScreenWrapper__top-bar {
          .MaterialBack {
            text-decoration: none;
          }

          ${
            moveBackButtonToBottom &&
            css`
              order: 1;

              .MaterialBack {
                width: 100%;
                padding: 1.2rem 0;
              }
            `
          }
        }

        .ScreenWrapper__inner-container {
          padding: ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(5)};

          ${
            moveBackButtonToBottom &&
            css`
              padding-bottom: 0;
            `
          }
        }

        .MuiInputBase-root {
          .MuiSelect-select {
            text-align: left;
            padding-right: ${theme.spacing(2)};
          }
        }
      }

      .ScreenWrapper__top-image {
        max-width: 8rem;
        margin: 0 auto ${theme.spacing(4)};
      }

      .ScreenWrapper__header {
        margin: 0 auto ${theme.spacing(4)};
      }

      .ScreenWrapper__actions {
        margin: ${theme.spacing(2)} 0;
        align-items: end;
        flex-direction: column;
        gap: ${theme.spacing(2)};

        .MaterialButtonWrapper {
          width: 100%;
        }

        .ScreenWrapper__disclaimer {
          margin-block-end: 0;
          align-self: center;
          color: ${theme.palette.grey.main};

          ${
            disclaimerVariant === 'contained'
              ? `
                padding: 1.6rem;
                border-radius: 0.8rem;
                background-color: #BCCECF33;
                margin-bottom: 2rem;
              `
              : ''
          };
        }
      }

      .ScreenWrapper__footer {
        display: none;
      }

      .MuiFormControl-root .MuiFormControlLabel-root {
        align-items: center;
        text-align: start;
        line-height: 1;

        .MuiButtonBase-root {
          margin-top: 0;
        }
      }

      ${theme.breakpoints.up('sm')} {
        .ScreenWrapper__progress-bar {
          border-radius: 0.8rem 0.8rem 0 0;
          padding: 0;

          .MuiStepConnector-root {
            right: calc(50% + 30px);
            left: calc(-50% + 30px);
          }
        }

        .ScreenWrapper__header {
          max-width: 53.6rem;
        }

        .ScreenWrapper__inner {
          background-position: left top;
          background-size: auto;
          max-width: 102.8rem;
          height: 80rem;
          padding: unset;

          .ScreenWrapper__inner-container {
            padding: 0 ${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)};

            &.progressBar {
              padding: ${backButton?.show || isFinal ? 0 : theme.spacing(2)} 0 ${theme.spacing(3)};
              min-height: 20rem;
            }

            .ScreenWrapper__content {
              height: 100%;
              margin: 0 auto;
              width: 43.8rem;

              .MaterialIDV {
                height: 100%;
              }
            }

            .ScreenWrapper__actions {
              margin: ${theme.spacing(2)} auto 0;
              width: 43.8rem;
            }

            #idv-iframe {
              min-height: 100%;
            }

            .ScreenWrapper__footer {
              display: flex;
              align-self: center;
              margin-top: ${theme.spacing(3)};
            }
          }

          .ScreenWrapper__top-bar {
            padding: 0 ${theme.spacing(5)};
            margin-bottom: unset;
          }
        }
      }

      ${
        (isFinal || isCentered) &&
        css`
          .ScreenWrapper__inner .ScreenWrapper__inner-container {
            .ScreenWrapper__top-image {
              margin-top: ${theme.spacing(16)};
            }

            .centered {
              margin-top: ${theme.spacing(28)};
            }

            > .ScreenWrapper__actions {
              margin-top: auto;
              flex-grow: 0;
            }
          }
        `
      }
    `;
  }}
`;

const MorningPageWrapper = (props) => {
  const { t, i18n } = useTranslation();
  const { actions } = useContext(MainContext);

  const isMobileDevice = isMobile().any;

  const currentStepName = actions.userState.getCurrentStepName();
  const { footerImageSrc } = actions.settings.getUserConfigProp(`custom.${currentStepName}`) ?? {};
  const moveBackButtonToBottom =
    actions.settings.getUserConfigProp(`widgetsConfig.screenWrapper.moveBackButtonToBottom`) ?? false;

  return (
    <Wrapper
      moveBackButtonToBottom={moveBackButtonToBottom && isMobileDevice}
      footer={
        footerImageSrc && (
          <img
            src={footerImageSrc}
            alt={i18n.exists(`${currentStepName}.footerAlt`) ? t(`${currentStepName}.footerAlt`) : ''}
          />
        )
      }
      {...props}
    />
  );
};

export default MorningPageWrapper;
